export default __webpack_public_path__ + "static/media/aafe-login.50fc9029.png";